import { http } from "@/lib/api";

const KEY = "sr_admin_token";
export const getToken = () => localStorage.getItem(KEY);
export const setToken = (t) => (t ? localStorage.setItem(KEY, t) : localStorage.removeItem(KEY));
export const authHeaders = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const errorText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};

export const adminApi = {
  login: (email, password) => http.post("/auth/login", { email, password }),
  me: () => http.get("/auth/me", authHeaders()),
  summary: () => http.get("/admin/summary", authHeaders()),
  requests: () => http.get("/admin/test-requests", authHeaders()),
  waitlist: () => http.get("/admin/waitlist", authHeaders()),
  setStatus: (id, status) => http.patch(`/admin/test-requests/${id}`, { status }, authHeaders()),
  setRebate: (id, paid) => http.patch(`/admin/test-requests/${id}/rebate`, { paid }, authHeaders()),
  delRequest: (id) => http.delete(`/admin/test-requests/${id}`, authHeaders()),
  delWaitlist: (id) => http.delete(`/admin/waitlist/${id}`, authHeaders()),
  changePassword: (current_password, new_password) => http.post("/auth/change-password", { current_password, new_password }, authHeaders()),
};
